(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceTypeController', InsuranceTypeController);

    InsuranceTypeController.$inject = ['InsuranceType', 'CoreService', 'GenericEntityDatatableService',
        '$q', '$uibModal', 'ConfirmationService'];

    function InsuranceTypeController(InsuranceType, CoreService, GenericEntityDatatableService,
                                     $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()
        var entityStateName = 'insurance-type'

        vm.descriptor = {
            title: 'Insurance Types',
            entityClassHumanized: 'Insurance Types',
            newButtonTitle: 'New Insurance Type',
            entityStateName: entityStateName,
            service: InsuranceType,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-type/update/insurance-type-dialog.html',
                controller: 'InsuranceTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-type/update/insurance-type-dialog.html',
                controller: 'InsuranceTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceType', function (InsuranceType) {
                        return InsuranceType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Type').result.then(function () {
                    InsuranceType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
